import { useAppSelector } from "../redux/hooks";
import { appConfigSelectors } from "../slices/appConfigSlice";

export const useCompSeasonId = () => useAppSelector(appConfigSelectors.selectCompSeasonId);
